/**
 * Impl dos use cases de participantes de agendamento + lookup de docentes por disciplina.
 *
 * @since G.5.17
 */
import type { AgendamentoParticipante, RegistrarPresencaCommand } from '@/domain/model/AgendamentoParticipante';
import type { DocenteAssignment } from '@/domain/model/Docente';
import type { AgendamentoParticipanteGateway } from '@/application/port/out/AgendamentoParticipanteGateway';
import type { DisciplineDocentesGateway } from '@/application/port/out/DisciplineDocentesGateway';
import type {
  ListParticipantesUseCase, AdicionarParticipanteUseCase, ConfirmarParticipanteUseCase,
  CancelarParticipanteUseCase, RegistrarPresencaUseCase,
} from '@/application/port/in/AgendamentoParticipanteUseCase';
import type { ListDocentesByDisciplineUseCase } from '@/application/port/in/DisciplineDocentesUseCase';

export class ListParticipantes implements ListParticipantesUseCase {
  constructor(private readonly g: AgendamentoParticipanteGateway) {}
  execute(agendamentoId: string): Promise<AgendamentoParticipante[]> { return this.g.listByAgendamento(agendamentoId); }
}
export class AdicionarParticipante implements AdicionarParticipanteUseCase {
  constructor(private readonly g: AgendamentoParticipanteGateway) {}
  execute(agendamentoId: string, alunoId: string): Promise<AgendamentoParticipante> { return this.g.adicionar(agendamentoId, alunoId); }
}
export class ConfirmarParticipante implements ConfirmarParticipanteUseCase {
  constructor(private readonly g: AgendamentoParticipanteGateway) {}
  execute(agendamentoId: string, alunoId: string): Promise<AgendamentoParticipante> { return this.g.confirmar(agendamentoId, alunoId); }
}
export class CancelarParticipante implements CancelarParticipanteUseCase {
  constructor(private readonly g: AgendamentoParticipanteGateway) {}
  execute(agendamentoId: string, alunoId: string, motivo: string): Promise<void> { return this.g.cancelar(agendamentoId, alunoId, motivo); }
}
export class RegistrarPresenca implements RegistrarPresencaUseCase {
  constructor(private readonly g: AgendamentoParticipanteGateway) {}
  execute(agendamentoId: string, alunoId: string, cmd: RegistrarPresencaCommand): Promise<AgendamentoParticipante> {
    return this.g.registrarPresenca(agendamentoId, alunoId, cmd);
  }
}
export class ListDocentesByDiscipline implements ListDocentesByDisciplineUseCase {
  constructor(private readonly g: DisciplineDocentesGateway) {}
  execute(disciplineId: string): Promise<DocenteAssignment[]> { return this.g.listByDiscipline(disciplineId); }
}
